/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenTabletVIcon64Regular = forwardRef('TechScreenTabletVIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M21.5 47a1.5 1.5 0 0 0 0 3h21a1.5 1.5 0 0 0 0-3h-21Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.5 6C14.701 6 10 10.701 10 16.5v31C10 53.299 14.701 58 20.5 58h23C49.299 58 54 53.299 54 47.5v-31C54 10.701 49.299 6 43.5 6h-23ZM13 16.5A7.5 7.5 0 0 1 20.5 9h23a7.5 7.5 0 0 1 7.5 7.5v31a7.5 7.5 0 0 1-7.5 7.5h-23a7.5 7.5 0 0 1-7.5-7.5v-31Z" })));
});
